module.exports = __webpack_public_path__ + "img/ms_b1_img1.c971578a.png";